import { IconProps } from './IconProps';

export const CrossCircle = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.05257 7.54418L10.3422 9.8338L9.628 10.548L7.33837 8.25837L5.03825 10.5585L4.32405 9.84431L6.62418 7.54418L4.33455 5.25456L5.04875 4.54036L7.33837 6.82999L9.6385 4.52986L10.3527 5.24405L8.05257 7.54418Z"
        fill={props.fill ?? '#ffffff'}
      />
      <circle
        cx="7.32812"
        cy="7.54395"
        r="6.32812"
        stroke={props.fill ?? '#ffffff'}
      />
    </svg>
  );
};

